import PublicNavbar from "components/ui/v2/navbar/PublicNavbar";
import { FC, ReactNode } from "react";

interface PublicWithHeaderProps {
  children: ReactNode;
}

const PublicWithHeader: FC<PublicWithHeaderProps> = ({ children }) => (
  <div className="grid h-full min-h-dvh content-start overflow-y-auto">
    <PublicNavbar />
    {children}
  </div>
);

export default PublicWithHeader;
